import { readonly, ref } from 'vue';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import useMemberProduct from '~/composables/useMemberProduct';
import useProductImagesCtaActions from './useProductImagesCtaActions';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';

export default function usePartOfCollection() {
  const isAdded = ref(false);
  const { isMemberProduct } = useProductFlags();
  const { masterProductUrl, orderedSiblingProductIds } = useMemberProduct();
  const { addCtaItem } = useProductImagesCtaActions();
  const { isShopTheCollectionCarouselEnabled } = useFeatureEligibility();

  const init = () => {
    if (isMemberProduct && orderedSiblingProductIds.value && !isShopTheCollectionCarouselEnabled) {
      addCtaItem({
        customCssClass: 'font-small',
        id: 'partOfCollection',
        label: 'PART OF A COLLECTION',
        onClickHandler: () => {},
        url: masterProductUrl.value,
        allowOpeningInNewTab: true,
      });

      isAdded.value = true;
    }
  };

  return {
    init,
    isAdded: readonly(isAdded),
  };
}
